import React, { useRef } from "react";
import st from './WorkItemStatuses.module.scss';
import { Carousel, CarouselRef, Tooltip } from "@infobis/ui-styles-utils";
import { formatNumber2d } from "@utils/format/number";
import { Status } from "@pages/dashboard/works/components/WorkItem/WorkItem";
import { ChartCircle } from "@modules/dashboards/dashboardTooltips/TooltipVariants/Circle/ChartCircle";
import cn from "classnames";
import Badge from "@pages/dashboard/works/components/Badge/Badge";

type WorkItemStatusesProps = {
	statuses: Status[]
	statusesLoading: boolean
}

const WorkItemStatuses = ({ statuses, statusesLoading }: WorkItemStatusesProps) => {
	const carouselRef = useRef<CarouselRef>(null)

	if (statusesLoading) {
		return <span className={st['loading']}>Статусы загружаются...</span>
	}

	return (
		<Carousel carouselRef={carouselRef}
				  gap={4}
				  carouselOptions={{ circular: false, moveType: 'freeScroll', cameraClass: st['camera'] }}
		>
			{statuses.map(status =>
				<Tooltip trigger={'hover'}
						 text={
							[
								<div key={`status-tooltip-${status.statusCode}-text`}
									 className={st['tooltip']}>
									<ChartCircle text={status.name} color={status.color} />
								</div>,
								<span key={`status-tooltip-${status.statusCode}-value`}>
									{formatNumber2d(status.value)}
								</span>
							]
						 }
						 bodyClassName={cn(st['tooltip'], st['tooltip__body'])}
						 key={`${status.name}-${status.value}-${status.color}-${status.statusCode}`}
				>
					<Badge status={status.statusCode} value={formatNumber2d(status.value)} />
				</Tooltip>
			)}
		</Carousel>
	)
}

export default WorkItemStatuses;